import React, { useEffect, useState } from "react";
import { Slide, Button, Box } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { Link, Paper } from "@material-ui/core";
import * as APIStore from "../store/APIStore";
import { connect } from "react-redux";
import { RouteComponentProps, useParams } from "react-router";
import { ApplicationState } from "../store";
import RequestAccessToken from '../util/authService';
import Typography from "@material-ui/core/Typography";
import SystemUpdateAltOutlinedIcon from '@material-ui/icons/SystemUpdateAltOutlined';
import { blue } from "@material-ui/core/colors";

type PtMedicalRecordProps = {
    MedicalRecord: APIStore.FocusMedicalRecordState,

} & typeof APIStore.actionCreators & RouteComponentProps<{ ptid: string, recordName: string }>;


const PtMedicalRecordDisplay = (props: PtMedicalRecordProps) => {
    let { requestPatientDocument, MedicalRecord } = props;
    let [fetchRequested, setFetchRequested] = useState(false);
    let [medicalRecordEntry, setMedicalRecordEntry] = useState<APIStore.PatientMedicalRecord>()
    let [tokenState, setTokenState] = useState<APIStore.TokenType>();

    let { condensedName, ptid } = useParams();


    useEffect(() => {
        if (MedicalRecord?.isLoaded) {
            if (MedicalRecord.medicalRecord) {
                setMedicalRecordEntry(MedicalRecord.medicalRecord)
            }
        }

    }, [tokenState, MedicalRecord])

    const downloadContent = (e: any) => {
        e.preventDefault();
        if (MedicalRecord?.medicalRecord) {
            const blbContent = new Blob([MedicalRecord.medicalRecord.content], { type: "text/plain" });
            let a = document.createElement("a")
            a.href = window.URL.createObjectURL(blbContent);
            a.download = MedicalRecord.medicalRecord.recordName;
            a.click();
        }
    }

    let tokenStatePr = RequestAccessToken()
        .then((token) => {
            if (token && !tokenState) {
                setTokenState(token);
            }
        });

    if (!fetchRequested) {
        if (tokenState) {
            setFetchRequested(true)

            requestPatientDocument(ptid, condensedName, tokenState.accessToken)
        }
    }

    if (medicalRecordEntry) {
        return (
            <div className="maincontent">
                <Paper elevation={1} style={{ padding: 10 }}>
                    <Grid container xs={12} justifyContent="space-between" alignContent="space-between" direction="row" spacing={2}>
                        <Grid item >
                            <Typography variant="body1" gutterBottom>
                                <strong>Name:{" "}</strong>
                                <Typography variant="body2" >
                                    {`${medicalRecordEntry.lastName}, ${medicalRecordEntry.firstName}`}
                                </Typography>
                            </Typography>
                        </Grid>
                        <Grid item >
                            <Typography variant="body1" gutterBottom>
                                <strong>Type:{" "}</strong>
                                <Typography variant="body2" >
                                    {medicalRecordEntry.recordType}
                                </Typography>
                            </Typography>
                        </Grid>
                        <Grid item >
                            <Typography variant="body1" gutterBottom>
                                <strong>Record Id:{" "}</strong>
                                <Typography variant="body2" >
                                    {medicalRecordEntry.recordName}
                                </Typography>
                            </Typography>
                        </Grid>

                        <Grid item >
                            <Typography variant="body1" gutterBottom>
                                <strong>Date:{" "}</strong>
                                <Typography variant="body2" >
                                    {medicalRecordEntry.createdDate}
                                </Typography>
                            </Typography>
                        </Grid>
                        <Grid item justifyContent="flex-end" alignContent="center">
                            <Button className="mui-auto-link" style={{ backgroundColor: "#00aad1", color: "#fff" }} onClick={(e) => downloadContent(e)} >
                                <SystemUpdateAltOutlinedIcon/>
                                <span>&nbsp;Download</span>
                            </Button>
                           
                      

                        </Grid>

                    </Grid>

                    <Paper style={{ padding: 20 }} elevation={6}>
                        <Box style={{ 'white-space': "pre" }}>
                            {MedicalRecord.medicalRecord?.content}
                        </Box>
                    </Paper>




                </Paper>
            </div>)

    }

    return (<>
        <p>Loading</p>
    </>)

};

export default connect(
    (state: ApplicationState) => state.vitalsContext,
    APIStore.actionCreators
)(PtMedicalRecordDisplay as any);
